import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillPaymentPaneWrapper = styled.div`
  margin-bottom: ${Spacing.S24};
`
